import React from "react";
import numeral from "numeral";
import { dollars } from "LIB/formatters/currency";
import { percent } from "LIB/formatters/number";
import T from "prop-types";
import { Stat } from "MODULES/shared/components";

export const purchasesSum = (data, country) => {
  const field = `${country ? country.toLowerCase() : "total"}_purchases`;
  const poTotal = data.buyers.reduce((sum, result) => sum + result[field], 0);
  if (country) return poTotal;
  return poTotal + Number(data.lot_purchases_total);
};

const totalRealizedSum = data =>
  data.buyers.reduce((sum, result) => sum + result.total_realized, 0);

const srpSum = data =>
  data.buyers.reduce((sum, result) => sum + result.total_srp, 0);

export function PurchasesCount({ data }) {
  return (
    <Stat
      label={`# Purchases`}
      value={numeral(data.num_purchases).format("(0,0)")}
    />
  );
}

PurchasesCount.propTypes = {
  data: T.arrayOf(T.shape({}))
};

export function SrpTotal({ data }) {
  return <Stat label="$ SRP Total" value={dollars(srpSum(data), 0)} />;
}

SrpTotal.propTypes = {
  data: T.shape({
    total_srp: T.number.isRequired
  })
};

export function TotalRealized({ data }) {
  return (
    <Stat
      label={"# Total Realized"}
      value={dollars(totalRealizedSum(data), 0)}
    />
  );
}

TotalRealized.propTypes = {
  data: T.shape({
    total_realized: T.number.isRequired
  })
};

export function TotalRealizedPercent({ data }) {
  return (
    <Stat
      label={"% Realized"}
      value={percent(totalRealizedSum(data), purchasesSum(data))}
    />
  );
}

TotalRealizedPercent.propTypes = {
  data: T.shape({
    total_realized: T.number.isRequired,
    total_purchased: T.number.isRequired
  })
};

export function PurchaseLinesCount({ data }) {
  return (
    <Stat
      label={"# PO Lines"}
      value={numeral(data.num_line_items).format("(0,0)")}
    />
  );
}

PurchaseLinesCount.propTypes = {
  data: T.arrayOf(T.shape({}))
};

export function PurchasesSum({ data, country }) {
  return (
    <Stat
      label={`$ Purchases ${country ? country.toUpperCase() : "Total"}`}
      value={numeral(purchasesSum(data, country)).format("($0,0)")}
    />
  );
}

PurchasesSum.propTypes = {
  country: T.string,
  data: T.shape({
    num_purchases: T.number.isRequired,
    num_line_items: T.number.isRequired,
    buyers: T.arrayOf({})
  })
};

export function LotPurchasesSum({ data }) {
  return (
    <Stat
      label="$ Lot Purchases Total"
      value={numeral(data.lot_purchases_total).format("($0,0)")}
    />
  );
}

LotPurchasesSum.propTypes = {
  data: T.shape({
    num_purchases: T.number.isRequired,
    num_line_items: T.number.isRequired,
    buyers: T.arrayOf({})
  })
};



// WEBPACK FOOTER //
// ./app/modules/PurchasesDashboard/Components/Stats.jsx